import { ReactElement } from 'react';

import { FilterPanel } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { WaitlistFilterPanelFormBean } from './WaitlistFilterPanel.types';
import { HealthcareProviderLocationController } from './controllers/healthcareProviderLocation/HealthcareProviderLocationController';
import { WaitlistFilterPanelLoader } from './WaitlistFilterPanel.loader';
import { PractitionersController } from './controllers/practitioners/PractitionersController';
import { ReservationPreferenceController } from './controllers/reservationPreference/ReservationPreferenceController';
import { StatusController } from './controllers/status/StatusController';
import { UrgentController } from './controllers/urgent/UrgentController';
import { EncounterModesController } from './controllers/encounterModes/EncounterModesController';
import { ServicesController } from './controllers/servicesController/ServicesController';
import { PatientAvailabilityController } from './controllers/patientAvailability/PatientAvailabilityController';

export const WaitlistFilterPanel = (): ReactElement => (
   <WaitlistFilterPanelLoader>
      {({ locations, practitioners, services }) => (
         <FilterPanel<WaitlistFilterPanelFormBean> testId={'waitlistFilterPanel'}>
            {({ registerController }) => (
               <>
                  {protectFeature('searchingAllPractitioners') ? (
                     <PractitionersController registerController={registerController} practitioners={practitioners} />
                  ) : null}
                  {protectFeature(
                     'searchingPrivateMedicalServices',
                     <ServicesController registerController={registerController} services={services} />
                  )}
                  <PatientAvailabilityController registerController={registerController} />
                  {protectFeature(
                     'bookingVideoConsultations',
                     <EncounterModesController registerController={registerController} />
                  )}
                  <HealthcareProviderLocationController locations={locations} registerController={registerController} />
                  <ReservationPreferenceController registerController={registerController} />
                  <StatusController registerController={registerController} />
                  <UrgentController registerController={registerController} />
               </>
            )}
         </FilterPanel>
      )}
   </WaitlistFilterPanelLoader>
);
